import { useEffect, useState } from 'react';
import { App, Button, Select, Tag } from 'antd';
import { api } from '../../api';
import { ErrorNotice, PageHeader, Panel } from '../../components';
import { useLoad } from '../../lib';
import { BackToSettings } from './BackToSettings';

const valid = (name) => /^[a-z0-9][a-z0-9-]{1,18}[a-z0-9]$/.test(name);

export function RemoteHostSettings() {
    const { message } = App.useApp();
    const loaded = useLoad(() => api('/v1/admin/settings/remote').then((body) => body.settings));
    const [names, setNames] = useState([]);
    const [saving, setSaving] = useState(false);
    useEffect(() => { if (loaded.data) setNames(loaded.data.names); }, [loaded.data]);
    const required = loaded.data?.required ?? [];
    const changed = Boolean(loaded.data) && JSON.stringify([...names].sort()) !== JSON.stringify([...loaded.data.names].sort());
    async function save() {
        const normalized = [...new Set(names.map((name) => String(name).trim().toLowerCase()).filter(Boolean))];
        const bad = normalized.find((name) => !valid(name));
        if (bad) return void message.error(`“${bad}” must be 3–20 small letters, digits or dashes.`);
        setSaving(true);
        try {
            const body = await api('/v1/admin/settings/remote', { method: 'PUT', body: JSON.stringify({ names: normalized }) });
            setNames(body.settings.names);
            message.success('Blocked hostnames saved');
            await loaded.reload();
        } catch (error) {
            message.error(error instanceof Error ? error.message : 'Could not save blocked hostnames');
        } finally {
            setSaving(false);
        }
    }
    return <>
      <PageHeader title="Remote hostnames" description="Control which branded remote-access names customers cannot claim under kivonex.in." actions={<BackToSettings />}/>
      <ErrorNotice error={loaded.error}/>
      <Panel title="Blocked names" description="Type a name and press Enter. Changes apply immediately and are stored in the cloud database.">
        <Select
          mode="tags"
          tokenSeparators={[',', ' ']}
          value={names}
          onChange={(values) => setNames([...new Set([...required, ...values.map((name) => String(name).trim().toLowerCase())])])}
          options={required.map((name) => ({ value: name, label: name, disabled: true }))}
          placeholder="Add a blocked hostname"
          maxTagCount="responsive"
          style={{ width: '100%' }}
          loading={loaded.loading}
        />
        <p className="cell-sub" style={{ marginTop: 10 }}>
          Required names {required.map((name) => <Tag key={name}>{name}</Tag>)} are protected in code and cannot be removed. Names must be 3–20 characters.
        </p>
        <div className="form-actions">
          <Button type="primary" onClick={() => void save()} loading={saving} disabled={!changed}>Save changes</Button>
        </div>
      </Panel>
    </>;
}
